import { Injectable } from "@angular/core";
import { CommonApiService } from "./common-api-service";
import { API_Const } from "../shared/constants/apiRouteConst";
import { EventService } from "./event.service";
import { PopupService } from "./popup.service";
import { TranslateService } from "@ngx-translate/core";
import { CURRENCY, STATUS_CODES } from "../shared/constants/app-enums";
import { BH_LOGIN_URL, sessionSubject } from "../shared/constants/common.constants";
import { HttpErrorResponse } from "@angular/common/http";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class GameAPIService {
  private static instance: GameAPIService;
  sessionSubject = new Subject<any>();
  private gameToken: any;

  constructor(
    private apiService: CommonApiService,
    private eventService: EventService,
    private popupService: PopupService,
    private translate: TranslateService,
  ) { 
    if(GameAPIService.instance) return GameAPIService.instance;
    GameAPIService.instance = this;
  }

  checkGameSession() {
    const session = localStorage.getItem("session");
    if (session) sessionSubject.next(session)
    else this.getSession();
  }

  removeSession() {
    sessionSubject.next('');
    localStorage.removeItem("session");
  }

  set setGameToken(gameToken: any) {
    if(!gameToken) return;
    this.gameToken = gameToken;
    this.getSession();
  }

  set setIsDemo(isDemo: boolean) {
    localStorage.setItem("isDemo", `${isDemo}`);
  }

  get getIsDemo() {
    return JSON.parse(localStorage.getItem("isDemo") as string);
  }

  set setGameSession(session: any) {
    localStorage.setItem("session", session);
    sessionSubject.next(session);
  }

  get sessionToken(): string | null {
    return localStorage.getItem("session");
  }

  getSession() {
    if (!this.getIsDemo && this.gameToken) {
      this.eventService.showSpinner();
      this.apiService
        .post(API_Const.lootboxes.authorize, {}, true, this.gameToken).subscribe((res) => {
          this.eventService.hideSpinner();
          if (res.message.toLowerCase() === "success") {
            this.setGameSession = this.gameToken;
          } else this.popupService.messagePopup("error", res.message);
        },
          (err: HttpErrorResponse) => {
            if(err.status === STATUS_CODES.UNAUTHORIZED){
              window.open(BH_LOGIN_URL, "_self");
            }
            this.eventService.hideSpinner();
            this.popupService.messagePopup("error", err.error?.message);
            this.removeSession();
          }
        );
    } else if (this.getIsDemo) this.popupService.messagePopup('error', this.translate.instant('lootbox_is_demo'));
    else if (!this.gameToken) this.popupService.messagePopup("error", this.translate.instant("launch_id_not_available"));
  }


  set userCurrency(currency: CURRENCY) {
    localStorage.setItem('currency', currency);
  }

  get userCurrency(): CURRENCY {
    return (localStorage.getItem('currency') as CURRENCY) || CURRENCY.USD;
  }

  set currentPlatform(platform: string) {
    localStorage.setItem('platform', platform);
  }

  get currentPlatform(): string {
    return localStorage.getItem('platform') as string;
  }
}
